<template>
  <div class="badInvoicePage" v-if="!this.showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field v-model="baseData.num" readonly label="发票号：" input-align="right" class="ggInput" />
      <van-field
        :value="baseData.typeName?baseData.typeName:''"
        readonly
        label="发票类型："
        input-align="right"
        class="ggInput"
      />
      <van-field
        :value="baseData.numAmount?baseData.numAmount:''"
        readonly
        label="申请发票金额（元）："
        input-align="right"
        class="ggInput dwBox"
      />
      <van-field
        :value="baseData.oppositeTallage?baseData.oppositeTallage:''"
        readonly
        label="对方单位税号："
        input-align="right"
        class="ggInput dwBox"
      />
      <van-field
        :value="baseData.operationName?baseData.operationName:''"
        readonly
        label="开票人："
        input-align="right"
        class="ggInput"
      />

      <van-field
        :value="baseData.operationTime?baseData.operationTime:''"
        readonly
        label="开票时间："
        input-align="right"
        class="ggInput"
      />

      <van-field
        :value="baseData.applicantIdName?baseData.applicantIdName:''"
        readonly
        label="作废人："
        input-align="right"
        class="ggInput"
      />
      <van-field
        :value="baseData.applyTime?baseData.applyTime:''"
        readonly
        label="作废时间："
        input-align="right"
        class="ggInput"
      />
      <van-field
        :value="baseData.reason?baseData.reason:''"
        readonly
        label="作废原因："
        input-align="right"
        class="ggInput beizhu"
      />
    </van-cell-group>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
import { dateFormat } from "@/utils/common";
export default {
  name: "badInvoice",
  data() {
    return {
      commonId: "",
      baseData: {}
    };
  },
  mounted() {
    this.commonId = this.$route.query.commonId; //开票Id
    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),

    
    initPage() {
      let _this = this;
   
      _this.$api.finance.invoice
        .getBadInvoice(_this.commonId)
        .then(res => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data);
            _this.baseData = res.data;
          }
           _this.setShowLoad(false);
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
           _this.setShowLoad(false);
        });
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.badInvoicePage {
  width: 100%;
  min-height: 100%;

  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #666;
      }
    }
  }
  .ggInput.beizhu {
    min-height: 45px;
  }
  .ggInput.dwBox {
    .van-cell__title {
      width: 160px;
    }
  }
}
</style>